import React from 'react';
import api from '../services/api';
import { getError } from '../utils/getResponseError';

const UserStateContext = React.createContext();
const UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, isAuthenticated: true, usuario: action.payload.usuario };
    case 'SIGN_OUT_SUCCESS':
      return { ...state, isAuthenticated: false, usuario: null };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  const [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!getUser(),
    usuario: getUser()
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  const context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error('useUserState must be used within a UserProvider');
  }
  return context;
}

function useUserDispatch() {
  const context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error('useUserDispatch must be used within a UserProvider');
  }
  return context;
}

export {
  UserProvider, useUserState, useUserDispatch, loginUser, signOut
};

// ###########################################################

async function loginUser(dispatch, email, senha, history, setIsLoading, setError, setErrorText) {
  try {
    setError(false);
    setIsLoading(true);

    const { data } = await api.post('/auth', {
      email,
      senha
    });

    saveUser(data);
    dispatch({ type: 'LOGIN_SUCCESS', payload: { usuario: data } });
    history.push('/app/dashboard');
    setIsLoading(false);
  } catch (error) {
    setError(true);
    setErrorText(getError(error));
    setIsLoading(false);
  }
}

function signOut(dispatch, history) {
  sessionStorage.removeItem('user');
  dispatch({ type: 'SIGN_OUT_SUCCESS' });
  api.defaults.headers.authorization = null;
  history.push('/login');
}

function saveUser(user) {
  const data = JSON.stringify(user);
  sessionStorage.setItem('user', data);
}

function getUser() {
  const user = sessionStorage.getItem('user');
  if (user) {
    const parse = JSON.parse(user);
    return parse;
  }
  return null;
}
